import type { IconData } from '@stacksjs/iconify-core'

export const beautyMirror2: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M25.145 4.57h-1.53V3.05H22.1V1.53h-1.53V0h-9.14v1.53H9.9v1.52H8.375v1.52h-1.52V6.1h-1.52v12.19h1.52v1.52h1.52v1.53h3.05v1.52h1.53v7.62h1.52V32h3.05v-1.52h1.52v-7.62h1.52v-1.52h3.05v-1.53h1.53v-1.52h1.52V6.1h-1.52Zm-7.62 24.39H16v-3.05h1.53Zm6.09-10.67H22.1v1.52h-3.05v1.53h-6.09v-1.53H9.9v-1.52H8.375V6.1H9.9V4.57h1.52V3.05h9.14v1.52h1.54V6.1h1.52Z\"/><path fill=\"currentColor\" d=\"M17.525 13.72h1.52v1.52h-1.52Zm0-3.05h1.52v1.52h-1.52Zm-3.05 4.57h3.05v1.53h-3.05Zm-1.52-1.52h1.52v1.52h-1.52Zm0-3.05h1.52v1.52h-1.52Zm0-6.1h1.52V6.1h-1.52Zm-1.53 1.53h1.53v1.52h-1.53Zm-1.52 1.52h1.52v1.53h-1.52Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default beautyMirror2
